<div class="bg-white dark:bg-gray-900/50 rounded-md w-full">
    <div class="p-2 overflow-x-auto h-96">
        <div class="inline-block min-w-full shadow rounded-lg overflow-hidden">

            <table class="w-full text-center text-gray-900 dark:text-gray-300">

                <thead>
                    <tr class="border-b-2 border-gray-200 dark:border-gray-600 bg-gray-100 dark:bg-gray-900/50 text-gray-600 dark:text-gray-300">
                        <th>No.</th>
                        <th>Hora</th>
                        <th>Carril</th>
                        <th>Clase</th>
                        <th>Proveniente</th>
                        <th>Comentario operativo</th>
                    </tr>
                </thead>
                <tbody>

                  <tr *ngFor="let evento of retornos; let i = index" class="border-b border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-900/50">

                    <td class="p-2">{{ i + 1 }}</td>

                    <td class="p-2">
                        {{ evento.retornos.fecha_hora | date:'dd/MM/yyyy HH:mm:ss' }}
                    </td>

                    <td class="p-2">
                        {{ evento.corte_usuario.carril.nombre }}
                    </td>

                    <td class="p-2">
                        {{ evento.tipo_vehiculo.tipo }}
                    </td>
                    <td class="p-2">
                        {{ evento.retornos.proveniente.nombre }}
                    </td>
                    <td class="p-2">
                        {{ evento.retornos.comentario_operativo }}
                    </td>

                </tr>

                </tbody>
            </table>

        </div>
    </div>
</div>
